import { render } from "./ArticleEdit.vue?vue&type=template&id=bb0213d8&scoped=true"
import script from "./ArticleEdit.vue?vue&type=script&lang=js"
export * from "./ArticleEdit.vue?vue&type=script&lang=js"

import "./ArticleEdit.vue?vue&type=style&index=0&id=bb0213d8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb0213d8"]])

export default __exports__